import * as React from 'react';
import './home.css';
import { Space, Card, Button, Tabs } from 'antd';
import { useState, useEffect } from 'react';
import { GuestLayout } from '../../components/layout/guest-layout';
import Link from 'react-dom';
import { Image } from 'antd';
import liff from "@line/liff";
import ResponsiveImage from '../../components/image/image';
import Cookies from 'js-cookie';
import { useCookies } from 'react-cookie';

export default function Home() {

  const path = () => {
    enterLoading(0);
    initLine();
    // window.location = '/register';
  }

  const [loadings, setLoadings] = useState([]);
  const enterLoading = (index) => {
    setLoadings((prevLoadings) => {
      const newLoadings = [...prevLoadings];
      newLoadings[index] = true;
      return newLoadings;
    });
    setTimeout(() => {
      setLoadings((prevLoadings) => {
        const newLoadings = [...prevLoadings];
        newLoadings[index] = false;
        return newLoadings;
      });
    }, 15000);
  };


  const [displayName, setDisplayName] = useState("");
  const [userId, setUserId] = useState("");

  useEffect(() => {
    Cookies.remove('jwt');
    Cookies.remove('phone');
  }, []);

  const initLine = () => {
    liff.init({ liffId: '1656876402-q23ZZ9mn' }, () => {
      if (liff.isLoggedIn()) {
        runApp();
      } else {
        liff.login();
      }
    }, err => console.error(err));
  }

  const runApp = () => {
    liff.getProfile().then(profile => {
      console.log("Linee profileee", profile);
      setDisplayName(profile.displayName);
      setUserId(profile.userId);
    }).catch(err => console.error(err));
  }

  return (
    <GuestLayout title={"เข้าสู่ระบบ"}>
      <div className='contents'>
        <div className='imagebewell'>
          {/* <Image
              width={340}
              src="/bewellstyle.png"
          /> */}
          <ResponsiveImage />
        </div>
        <br />
        <div className='buttonregis'>
          <Button loading={loadings[0]} onClick={path}>ลงทะเบียนรับประกันสินค้า</Button>
        </div>
      </div>



    </GuestLayout>
  );
}